export type ExecutionStatus = 'idle' | 'running' | 'success' | 'error' | 'skipped';

/** Returns additional CSS classes for the node container based on execution status */
export function getExecutionBorderClass(status?: ExecutionStatus): string {
  switch (status) {
    case 'running':
      return 'ring-2 ring-blue-400 ring-offset-1 shadow-lg shadow-blue-200/50 animate-pulse';
    case 'success':
      return 'ring-2 ring-green-400 ring-offset-1 shadow-green-200';
    case 'error':
      return 'ring-2 ring-red-400 ring-offset-1 shadow-red-200';
    case 'skipped':
      return 'opacity-50';
    default:
      return '';
  }
}

